import React from "react";
import { Routes, Route } from "react-router-dom";

import "./styles/badges-styles.css";
import "./styles/calendar-styles.css";
import "./styles/contact-us-styles.css";
import "./styles/files-styles.css";
import "./styles/home-styles.css";
import "./styles/replacements-styles.css";
import "./styles/sections-styles.css";
import "./styles/multi-page-styles.css";
import "./styles/global-styles.css";

import Home from "./pages/home";
import Beavers from "./pages/beavers";
import Cubs from "./pages/cubs";
import Scouts from "./pages/scouts";
import Calendar from "./pages/calendar";
import ContactUs from "./pages/contact-us";
import Files from "./pages/files";
import Badges from "./pages/badges";
import Replacements from "./pages/replacements";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/beavers" element={<Beavers />} />
      <Route path="/cubs" element={<Cubs />} />
      <Route path="/scouts" element={<Scouts />} />
      <Route path="/calendar" element={<Calendar />} />
      <Route path="/contact" element={<ContactUs />} />
      <Route path="/files" element={<Files />} />
      <Route path="/badges" element={<Badges />} />
      <Route path="/replacements" element={<Replacements />} />
    </Routes>
  );
}

export default App;